import AnnounceKit from 'announcekit-react';
import React from 'react';
import { Host } from '../../Host';
import { Icon } from '../../concepts/resources/Icon';
import { HeaderButton } from '../../ui/HeaderButton';
import { Tip } from '../../ui/Tip';

export const UpdatesButton = () => {
    return !Host.kiosk && <>
        <style dangerouslySetInnerHTML={{
            __html: `
                .announcekit-widget-badge { position: absolute !important; top: 0 !important; right: 0 !important; }
            `
        }} />
        <Tip text="Release Notes" position="bottom">
            <AnnounceKit widget="https://updates.metroretro.io/widgets/v2/4491qU">
                <HeaderButton className="announcekit-widget" style={{ position: 'relative' }}>
                    <Icon size="1.5" src="deqo://icons/deqo/ship" />
                </HeaderButton>
            </AnnounceKit>
        </Tip>
    </>;
};

